import script from "./OidoPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoPhoneInput.vue?vue&type=style&index=0&id=399cf8ca&scoped=true&lang=css"
import "./OidoPhoneInput.vue?vue&type=style&index=1&id=399cf8ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-399cf8ca"]])

export default __exports__